<template>
    <v-app class="bg-white">
    <v-main class="auth-pages"  >
        <v-col cols="12" style="display: flex; justify-content: space-around;margin-top: 10px;" >
                  <img :height="this.$vuetify.breakpoint.xs ? 200 : 200" class="image-logo2" src="@/assets/img/logo.png">
            </v-col>
            <div class="terms-conditions container">
              <div class="header-section text-center mb-4">
                <h1>🏠 HomeSyncX™️</h1>
                <p class="operated-by">Operated by Round Tables LLC</p>
                <p class="contact-info">
                  📧 <a href="mailto:support@homesyncx.com">support@homesyncx.com</a> | 🌐 <a href="https://www.homesyncx.com" target="_blank">www.homesyncx.com</a>
                </p>
              </div>

              <h1 class="text-center main-title">HomeSyncX™️ Terms of Service, Privacy Policy, Cookie Policy & Compliance Statement</h1>
              <p class="last-updated text-center">Effective Date: October 26, 2025</p>
          
              <section>
                <h2>1. Terms of Service</h2>
                
                <h3>Acceptance of Terms</h3>
                <p>
                  By accessing or using the HomeSyncX™️ platform, website, or any related services, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, discontinue use immediately.
                </p>
                
                <h3>Description of Service</h3>
                <p>
                  HomeSyncX™️ is a real-estate referral and automation platform allowing agents, brokers, investors, and partners to share listings, refer clients, and earn commissions through verified transactions.
                </p>
                
                <h3>Eligibility</h3>
                <p>
                  Users must be 18 years or older and legally authorized to enter contracts. Agents and brokers must comply with real-estate licensing laws in their jurisdiction.
                </p>
                
                <h3>User Accounts</h3>
                <p>
                  Maintain accurate account information. Sharing logins is prohibited. HomeSyncX™️ may suspend or terminate accounts for misuse or false data.
                </p>
                
                <h3>Commissions & Referrals</h3>
                <p>
                  HomeSyncX tracks referrals and commissions but does not act as a brokerage or financial institution. Disbursements may be handled by licensed brokers or title companies.
                </p>
                
                <h3>Prohibited Conduct</h3>
                <p>Users may not:</p>
                <ul>
                  <li>Post false or misleading info</li>
                  <li>Engage in fraud or unethical practices</li>
                  <li>Attempt to disrupt, hack, or copy the platform</li>
                  <li>Resell, redistribute, or misuse branding</li>
                </ul>
                
                <h3>Intellectual Property</h3>
                <p>
                  All content and trademarks, including the HomeSyncX name and logo, belong to Round Tables LLC.
                </p>
                
                <h3>Limitation of Liability</h3>
                <p>
                  HomeSyncX is provided "as is." We are not liable for loss of profits, data, or business resulting from use.
                </p>
                
                <h3>Termination</h3>
                <p>
                  We may suspend or remove accounts for any breach without prior notice.
                </p>
              </section>
          
              <section>
                <h2>2. Privacy Policy</h2>
                
                <h3>Information We Collect</h3>
                <ul>
                  <li>Name, email, phone number</li>
                  <li>Business & license details</li>
                  <li>Payment or commission info (if applicable)</li>
                  <li>Usage data (logins, referrals, performance)</li>
                </ul>
                
                <h3>How We Use It</h3>
                <ul>
                  <li>Operate and improve the platform</li>
                  <li>Facilitate referrals and communications</li>
                  <li>Provide support and updates</li>
                </ul>
                
                <h3>Data Protection</h3>
                <p>
                  Data is stored securely with encryption and limited access.
                </p>
                
                <h3>Information Sharing</h3>
                <p>
                  We do not sell your data. It may be shared with verified partners (brokers, mortgage lenders, title companies) only as needed for transactions or compliance.
                </p>
                
                <h3>Your Rights</h3>
                <p>
                  Request to update or delete data anytime by emailing <a href="mailto:support@homesyncx.com">support@homesyncx.com</a>.
                </p>
              </section>
          
              <section>
                <h2>3. Cookie Policy</h2>
                
                <h3>Use of Cookies</h3>
                <p>We use cookies to:</p>
                <ul>
                  <li>Keep you logged in</li>
                  <li>Track referrals and activity</li>
                  <li>Analyze site performance</li>
                </ul>
                
                <h3>Types of Cookies</h3>
                <ul>
                  <li><strong>Essential</strong> – Required for functionality</li>
                  <li><strong>Analytics</strong> – Anonymous usage data</li>
                  <li><strong>Marketing</strong> – Used only with consent</li>
                </ul>
                
                <p>
                  Manage cookies in your browser settings at any time.
                </p>
              </section>
          
              <section>
                <h2>4. Compliance Statement</h2>
                <p>HomeSyncX complies with:</p>
                <ul>
                  <li>Federal and State Real Estate Laws</li>
                  <li>Fair Housing Act (FHA)</li>
                  <li>General Data Protection Regulation (GDPR)</li>
                  <li>California Consumer Privacy Act (CCPA)</li>
                </ul>
                
                <h3>Contact Compliance</h3>
                <p>
                   <a href="mailto:compliance@homesyncx.com">compliance@homesyncx.com</a><br>
                   Round Tables LLC | 931 N Dysart Rd Suite B, Avondale, AZ 85323
                </p>
              </section>
          
              <section>
                <h2>Final Clause</h2>
                <p>
                  Using HomeSyncX constitutes acceptance of these policies and acknowledgment of your responsibilities as a professional within the HomeSyncX ecosystem.
                </p>
              </section>
            </div>
    </v-main>
    </v-app>
  </template>
  
  <script>
  export default {
    name: 'TermsAndConditions',
  };
  </script>
  
  <style scoped>
  .terms-conditions {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 20px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.7;
    color: #333;
  }
  
  .header-section {
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 15px;
  }
  
  .header-section h1 {
    font-size: 2.5rem;
    font-weight: 700;
    color: #0052CC;
    margin-bottom: 10px;
  }
  
  .operated-by {
    font-size: 1.1rem;
    color: #666;
    margin: 5px 0;
  }
  
  .contact-info {
    font-size: 1rem;
    color: #666;
    margin-top: 10px;
  }
  
  .contact-info a {
    color: #0052CC;
    text-decoration: none;
  }
  
  .contact-info a:hover {
    text-decoration: underline;
  }
  
  .main-title {
    font-size: 2rem;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 10px;
  }
  
  .last-updated {
    font-size: 0.95rem;
    color: #666;
    margin-bottom: 40px;
    font-style: italic;
  }
  
  section {
    margin-bottom: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid #e0e0e0;
  }
  
  section:last-child {
    border-bottom: none;
  }
  
  h2 {
    font-size: 1.8rem;
    font-weight: 700;
    color: #0052CC;
    margin-bottom: 20px;
    margin-top: 0;
  }
  
  h3 {
    font-size: 1.3rem;
    font-weight: 600;
    color: #1a1a2e;
    margin-top: 25px;
    margin-bottom: 15px;
  }
  
  p {
    margin-bottom: 15px;
    font-size: 1rem;
    color: #444;
  }
  
  ul {
    margin: 15px 0;
    padding-left: 30px;
  }
  
  li {
    margin-bottom: 10px;
    font-size: 1rem;
    color: #444;
  }
  
  a {
    color: #0052CC;
    text-decoration: none;
  }
  
  a:hover {
    text-decoration: underline;
  }
  
  strong {
    font-weight: 600;
    color: #1a1a2e;
  }
  
  @media (max-width: 768px) {
    .terms-conditions {
      padding: 20px 15px;
    }
    
    .header-section h1 {
      font-size: 1.8rem;
    }
    
    .main-title {
      font-size: 1.5rem;
    }
    
    h2 {
      font-size: 1.4rem;
    }
    
    h3 {
      font-size: 1.1rem;
    }
  }
  </style>
